import { ServiceProvider } from '../../types'

const serviceProviders: ServiceProvider[] = [
	{
		id: 2,
		name: 'test',
		updated_at: null,
		created_at: null,
		template_url: 'https://some-url.com/99',
		template_id: '99'
	}
]

export default serviceProviders
